import React from 'react';
import { Box } from '@wix/design-system';
import { CARD_ZINDEX, HIGHLIGHTED_CARD_ZINDEX } from '../consts';
import { MarketingItemRow } from '../MarketingItemRow';
// This shadow is used a counter shadow to the divider highlight shadow.
// The divider shadow covers a small part of the inside of the card, so we need to negate it.
// Creates an illusion that the card has a shadow.
const INVERTED_BOX_SHADOW = '0 0 20px 20px white inset';
const LAST_CHILD_PADDING_BOTTOM = '30px';
export var CardElevation;
(function (CardElevation) {
    CardElevation[CardElevation["None"] = 0] = "None";
    CardElevation[CardElevation["Small"] = 10] = "Small";
    CardElevation[CardElevation["Medium"] = 20] = "Medium";
    CardElevation[CardElevation["Large"] = 30] = "Large";
    CardElevation[CardElevation["XL"] = 40] = "XL";
})(CardElevation || (CardElevation = {}));
export var HatPosition;
(function (HatPosition) {
    HatPosition[HatPosition["InsideCard"] = 0] = "InsideCard";
    HatPosition[HatPosition["OutsideCard"] = 1] = "OutsideCard";
})(HatPosition || (HatPosition = {}));
const CardItemWrapper = ({ children }) => (React.createElement(Box, { width: "85%", maxWidth: "206px", margin: "0 auto", align: "center" }, children));
export function ProductCardContainer({ dataHook, className, highlighted = false, elevated = CardElevation.None, hatPosition = HatPosition.InsideCard, hat, header, pricing, cta, marketingItems, background, }) {
    const highlightedBoxShadow = highlighted ? INVERTED_BOX_SHADOW : 'none';
    const zIndex = highlighted ? HIGHLIGHTED_CARD_ZINDEX : CARD_ZINDEX;
    const isHatOutsideCard = hatPosition === HatPosition.OutsideCard;
    return (React.createElement(Box, { className: className, dataHook: dataHook, display: "contents" },
        React.createElement(Box, { dataHook: "card-hat-container", padding: isHatOutsideCard ? undefined : 'SP1', paddingBottom: "0", direction: "vertical", align: elevated ? 'center' : undefined, zIndex: zIndex, boxShadow: highlightedBoxShadow }, elevated ? (React.createElement(Box, { position: "relative", background: background ?? 'white', padding: isHatOutsideCard ? undefined : 'SP1', width: "100%", top: `-${elevated}px`, height: isHatOutsideCard ? elevated : undefined }, hat)) : (hat)),
        React.createElement(Box, { zIndex: zIndex, boxShadow: highlightedBoxShadow },
            React.createElement(CardItemWrapper, null, header)),
        React.createElement(Box, { paddingBottom: "SP2", zIndex: zIndex, boxShadow: highlightedBoxShadow },
            React.createElement(CardItemWrapper, null, pricing)),
        React.createElement(Box, { zIndex: zIndex, boxShadow: highlightedBoxShadow },
            React.createElement(CardItemWrapper, null, cta)),
        marketingItems?.map((marketingItem, index) => {
            const lastChild = index === marketingItems?.length - 1;
            const paddingBottom = lastChild ? LAST_CHILD_PADDING_BOTTOM : '0';
            return (React.createElement(MarketingItemRow, { key: index, item: marketingItem, zIndex: zIndex, boxShadow: highlightedBoxShadow, paddingBottom: paddingBottom, className: className, disabled: marketingItem.disabled }));
        })));
}
//# sourceMappingURL=ProductCardContainer.js.map